import { createAsyncThunk } from "@reduxjs/toolkit";
import { getBranchTransactionReciveListApi } from "../../../apiservice/reports";
import { getBranchApi } from "../../../apiservice/setting";


export const fetchBranchTransferReceiveList = createAsyncThunk(
  "branchTransferReceive/fetch",
  async ({ filters }, { rejectWithValue }) => {
    try {
      const payload = {
        selectedFilterType: filters.filterType,
        fromBranchId: filters.fromBranchId || null,
        fromDate: filters.fromDate,
        toDate: filters.toDate,
      };
      const res = await getBranchTransactionReciveListApi(payload);
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || "Failed to fetch");
    }
  }
);

export const fetchBranches = createAsyncThunk(
  "branchLedger/fetchBranches",
  async (_, { rejectWithValue }) => {
    try {
      const res = await getBranchApi({ "without-self": "yes" });
      return res.data.message || [];
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

